import React, { useState, useEffect } from 'react';
import { Banner, Toast } from '@repo/common';

/**
 * 아이템이 더 이상 사용 불가능할 때 표시되는 모달
 * 시스템/타이밍 Error 발생시
 * 하단에서 슬라이드업 방식
 * Banner 컴포넌트 재사용
 */
const ItemUnavailableModal = ({ isOpen, onClose }) => {
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsClosing(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    setIsClosing(true);
    setTimeout(() => {
      onClose && onClose();
      setIsClosing(false);
    }, 300);
  };

  return (
    <>
      <div className='hidden tabletH:flex fixed bottom-0 left-0 right-0 z-[9999] justify-center pointer-events-none px-[20px] pb-[24px]'>
        <div
          className={`pointer-events-auto transition-transform duration-300 ease-out ${
            isClosing
              ? 'translate-y-full opacity-0'
              : 'translate-y-0 opacity-100'
          }`}
          style={{ minWidth: '360px', maxWidth: '600px', width: '100%' }}
        >
          <Banner
            type='warning'
            size='m'
            label='This item is no longer available'
            hideButton={true}
            hideClose={false}
            onClose={handleClose}
            width='100%'
            controlled={true}
            isVisible={!isClosing}
          />
        </div>
      </div>

      <div className='tabletH:hidden fixed bottom-[24px] left-0 right-0 px-4 z-[9999999] flex justify-center'>
        <Toast
          visibleOn='mobile'
          type='warning'
          state='white'
          hierarchy='small'
          title='This item is no longer available'
          message=''
          onClose={onClose}
          useSmallIcon={true}
          hideActions={true}
          direction='up'
          customWidth='auto'
        />
      </div>
    </>
  );
};

export default ItemUnavailableModal;
